module.exports = __webpack_public_path__ + "static/img/service_passprime_center.e9955f71.svg";